import React from "react";
import Navbar from "../components/Navbar";
import MyBookings from '../components/MyBookings'

const MyBooking = () => {
  return (
    <div>
      <Navbar />
      <MyBookings />
    </div>
  );
};

export default MyBooking;
